import { ChevronDown, ChevronRight } from "lucide-react";
import React from "react";
import { cn } from "@/lib/utils";

interface ExpandToggleProps {
  hasChildren?: boolean;
  isExpanded: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isSelected: boolean;
}

/**
 * 行の展開/折りたたみボタンコンポーネント
 */
const ExpandToggle: React.FC<ExpandToggleProps> = ({ hasChildren = false, isExpanded, onClick, isSelected }) => {
  if (!hasChildren) return <div className="w-0" />;

  return (
    <button
      onClick={onClick}
      className={cn(
        "mr-1 p-1 rounded-sm hover:bg-muted",
        isSelected && "hover:bg-yellow-200",
      )}
    >
      {isExpanded ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
    </button>
  );
};

export default ExpandToggle;
